<div *ngIf="notifyApplicant && templates"
  [ycHidden]="hideModal">

  <!-- Preview Template -->
  <div *ngIf="templates.length === 1 &&
    !showSingleOption"
    class="mb-3">
    <yc-button
      [link]="true"
      [langKey]="'common:lblPreviewEmail'"
      [defaultText]="'Preview email'"
      [fontAwesomeIcon]="'eye'"
      (onClick)="viewEmail(templates[0])">
    </yc-button>
  </div>

  <!-- Template Selector -->
  <div *ngIf="templates.length > 1 || showSingleOption"
    class="mt-2">
    <div class="mb-3">
      <yc-i18n
        key="GLOBAL:textSelectEmailTemplate"
        defaultValue="Select email template">
      </yc-i18n>
    </div>
    <div class="select-container">
      <yc-radio-buttons
        [name]="controlName"
        [options]="emailOptions"
        [controlled]="true"
        [sorted]="false"
        (onChange)="onEmailSelect()">
        <ng-container *ycSelectOptionLabelTemplate="let option; let id = id;">
          <label [for]="id">
            <div class="d-flex flex-column">
              <div class="d-flex align-items-center">
                <div>
                  {{ option.label }}
                </div>
                  
                <yc-button
                  class="ms-2"
                  [tooltipText]="'common:lblPreview' | ycI18n: 'Preview'"
                  [link]="true"
                  [fontAwesomeIcon]="'eye'"
                  (onClick)="viewProgramEmail(option.value)">
                </yc-button>
              </div>

              <div>
                {{ emailOptionsMap[option.value].subject }}
                <small class="d-block">
                  {{ emailOptionsMap[option.value].description }}
                </small>
              </div>
            </div>
          </label>
        </ng-container>
      </yc-radio-buttons>
    </div>
  </div>  

  <!-- CC / BCC -->
  <div *ngIf="showCcBcc">
    <div>
      <yc-tags
        [name]="ccControlName"
        [disabled]="!allowCcUpdates"
        [placeholder]="''"
        [secondaryPlaceholder]="''"
        [label]="'GLOBAL:textCC' | ycI18n: 'CC'">
      </yc-tags>
    </div>
    <div>
      <yc-tags
        [name]="bccControlName"
        [disabled]="!allowCcUpdates"
        [placeholder]="''"
        [secondaryPlaceholder]="''"
        [label]="'GLOBAL:textBCC' | ycI18n: 'BCC'">
      </yc-tags>
    </div>
  </div>

  <!-- Mail Merge -->
  <div *ngIf="allowMailMerge && mailMergeTemplate"
    class="mt-3">
    <yc-fa
      icon="mail-bulk"
      [light]="true"
      class="me-2">
    </yc-fa>
    <a class="anchor-tag"
      href="javascript:void(0)"
      (click)="openMailMergePreview()">
      {{ mailMergeTemplate.name + '.pdf' }}
    </a>
  </div>

  <!-- Attachments -->
  <div *ngIf="allowAttachments">
    <yc-add-attachment-button
      [attachments]="attachments"
      [maxAttachmentsTotalSize]="maxAttachmentsFileSize"
      (onAddAttachment)="addAttachment($event)"
      (onRemoveAttachment)="removeAttachment($event)">
    </yc-add-attachment-button>
  </div>

  <!-- Custom Message -->
  <div *ngIf="!!customMessageControlName"
    class="mt-3">
    <yc-alert *ngIf="missingCustomMessageToken"
      [message]="!!standardEmailName ?
        ('common:textTheEmailYouHaveSelectedDoesNotContainTheCustomMessageToken2' | ycI18n: 'The template you selected does not contain the custom message token. If you want to include a custom message in the email, select the standard email __standardEmailName__ or update template __templateName__ to include the custom message token.': {
        templateName: selectedTemplateName,
        standardEmailName: standardEmailName
      }) :
      ('common:textTheEmailYouHaveSelectedDoesNotContainTheCustomMessageToken3' | ycI18n: 'The template you selected does not contain the custom message token. If you want to include a custom message in the email, update template __templateName__ to include the custom message token.': {
        templateName: selectedTemplateName
      })"
      [alertClass]="'info'">
    </yc-alert>
    <yc-rich-text-editor *ngIf="!missingCustomMessageToken"
      [name]="customMessageControlName"
      [label]="customMessageLabel">
    </yc-rich-text-editor>
  </div>
</div>